export const FIELD_ALL = 'ALL';
export const FIELD_MAINF = 'MAINF';
export const FIELD_TA = 'TA';
export const FIELD_TTL = 'TTL';
export const FIELD_TAC = 'TAC';
export const FIELD_TACD = 'TACD';
export const FIELD_ABST = 'ABST';
export const FIELD_CLMS = 'CLMS';
export const FIELD_DESC = 'DESC';
export const FIELD_DESC_F = 'DESC_F';
export const FIELD_DESC_B = 'DESC_B';
export const FIELD_DESC_S = 'DESC_S';
export const FIELD_DESC_D = 'DESC_D';
export const FIELD_DESC_E = 'DESC_E';
export const FIELD_I_CLMS = 'I_CLMS';
export const FIELD_F_AN = 'F_AN';
export const FIELD_TTL_ALL = 'TTL_ALL';
export const FIELD_ABST_ALL = 'ABST_ALL';
export const FIELD_DESC_ALL = 'DESC_ALL';
export const FIELD_CLMS_ALL = 'CLMS_ALL';
export const FIELD_TA_ALL = 'TA_ALL';
export const FIELD_TACD_ALL = 'TACD_ALL';
export const FIELD_TAC_ALL = 'TAC_ALL';
export const FIELD_MAINF_ALL = 'MAINF_ALL';
export const FIELD_ICLMS_ALL = 'ICLMS_ALL';
export const FIELD_ALL_AN = 'ALL_AN';
export const FIELD_AN = 'AN';
export const FIELD_ANS = 'ANS';
export const FIELD_ANC = 'ANC';
export const FIELD_ANCS = 'ANCS';
export const FIELD_F_ANC = 'F_ANC';
export const FIELD_CLASS = 'CLASS';
export const FIELD_IPC = 'IPC';
export const FIELD_IPC_CPC = 'IPC_CPC';
export const FIELD_MIPC = 'MIPC';
export const FIELD_CPC = 'CPC';
export const FIELD_CPC_ALL = 'CPC_ALL';
export const FIELD_MCPC = 'MCPC';
export const FIELD_LOC = 'LOC';
export const FIELD_UPC = 'UPC';
export const FIELD_GBC = 'GBC';
export const FIELD_NEV = 'NEV';
export const FIELD_ADC = 'ADC';
export const FIELD_TTC = 'TTC';
export const FIELD_SEIC = 'SEIC';
export const FIELD_SEIC_ALL = 'SEIC_ALL';
export const FIELD_APD = 'APD';
export const FIELD_PBD = 'PBD';
export const FIELD_APD_Y = 'APD_Y';
export const FIELD_PBD_Y = 'PBD_Y';
export const FIELD_APD_YM = 'APD_YM';
export const FIELD_PBD_YM = 'PBD_YM';
export const FIELD_EFAM_EPBD = 'EFAM_EPBD';
export const FIELD_EFAM_EPBY = 'EFAM_EPBY';
export const FIELD_EFAM_EPBYM = 'EFAM_EPBYM';
export const FIELD_EFAM_EPRD = 'EFAM_EPRD';
export const EFAM_EPB_COUNTRY = 'EFAM_EPB_COUNTRY';
export const FIELD_ISD = 'ISD';
export const FIELD_EXPD = 'EXPD';
export const FIELD_PRIORITY_DATE = 'PRIORITY_DATE';
export const FIELD_EXDT = 'EXDT';
export const FIELD_PCTENTRY_DATE = 'PCTENTRY_DATE';
export const FIELD_LEGAL_STATUS_DATE = 'LEGAL_STATUS_DATE';
export const FIELD_VERDICT_DATE = 'VERDICT_DATE';
export const FIELD_LIC_EFDT = 'LIC_EFDT';
export const FIELD_LIT_CLOSEDT = 'LIT_CLOSEDT';
export const FIELD_FILING_DATE = 'FILING_DATE';
export const FIELD_HEARING_DATE = 'HEARING_DATE';
export const FIELD_TRANS_EFDT = 'TRANS_EFDT';
export const FIELD_PLE_EFDT = 'PLE_EFDT';
export const FIELD_RIDDT = 'RIDDT';
export const FIELD_EXAMINE_DATE = 'EXAMINE_DATE';
export const FIELD_F_PBD = 'F_PBD';
export const FIELD_E_PRIORITY_DATE = 'E_PRIORITY_DATE';
export const FIELD_FILING_YEAR = 'FILING_YEAR';
export const FIELD_CITES_COUNT = 'B_CITES_COUNT';
export const FIELD_CITEDBY_COUNT = 'F_CITES_COUNT';
export const FIELD_FAM_COUNT = 'FAM_COUNT';
export const FIELD_IFAM_COUNT = 'IFAM_COUNT';
export const FIELD_EFAM_COUNT = 'EFAM_COUNT';
export const FIELD_FAM_COUNTRY_COUNT = 'FAM_COUNTRY_COUNT';
export const FIELD_IFAM_COUNTRY_COUNT = 'IFAM_COUNTRY_COUNT';
export const FIELD_EFAM_COUNTRY_COUNT = 'EFAM_COUNTRY_COUNT';
export const FIELD_CLAIM_COUNT = 'CLAIM_COUNT';
export const FIELD_FCLMS_WORDCOUNT = 'FCLMS_WORDCOUNT';
export const FIELD_PV = 'PV';
export const FIELD_AN_COUNT = 'AN_COUNT';
export const FIELD_ANC_COUNT = 'ANC_COUNT';
export const FIELD_IN_COUNT = 'IN_COUNT';
export const FIELD_PAGE_COUNT = 'PAGE_COUNT';
export const FIELD_EXAMINE_PERIOD = 'EXAMINE_PERIOD';
export const FIELD_CPC_COUNT = 'CPC_COUNT';
export const FIELD_IPC_COUNT = 'IPC_COUNT';
export const FIELD_PRIORITY_COUNTRY_COUNT = 'PRIORITY_COUNTRY_COUNT';
export const FIELD_AMOUNT_PLAINTIFF = 'AMOUNT_PLAINTIFF';
export const FIELD_DAMAGES_AMOUNT = 'DAMAGES_AMOUNT';
export const FIELD_TRIAL_GRADE = 'TRIAL_GRADE';
export const FIELD_TRIAL_GRADE_CN = 'TRIAL_GRADE_CN';
export const FIELD_CASE_NATURE = 'CASE_NATURE';
export const FIELD_CASE_LEVEL = 'CASE_LEVEL';
export const FIELD_CASE_DOC_TYPE = 'CASE_DOC_TYPE';
export const FIELD_COURT_GRADE = 'COURT_GRADE';
export const FIELD_CASE_REGION = 'CASE_REGION';
export const FIELD_OUTCOME_STATUS = 'OUTCOME_STATUS';
export const FIELD_EXCLUSIVITY = 'EXCLUSIVITY';
export const FIELD_EXCLUSIVITY_CN = 'EXCLUSIVITY_CN';
// export const FIELD_PLE_TYPE = 'PLE_TYPE';
export const FIELD_PLESTAGE = 'PLESTAGE';
export const FIELD_RIDTP = 'RIDTP';
export const FIELD_RIDTP_CN = 'RIDTP_CN';
export const FIELD_RIDTP_EP = 'RIDTP_EP';
export const FIELD_LEGAL_STATUS = 'LEGAL_STATUS';
export const FIELD_LEGAL_EVENT = 'LEGAL_EVENT';
export const FIELD_SIMPLE_LEGAL_STATUS = 'SIMPLE_LEGAL_STATUS';
export const FIELD_EPDS = 'EPDS';
export const FIELD_EP_LEGAL_STATUS = 'EPDS_LS';
export const FIELD_EP_SIMPLE_LEGAL_STATUS = 'EPDS_SLS';
export const FIELD_ENTRY_COUNTRY = 'ENTRY_COUNTRY';
export const FIELD_ENTRY_COUNTRY_STATUS = 'ENTRY_COUNTRY_LS';
export const FIELD_ENTRY_COUNTRY_LEGAL_STATUS = 'ENTRY_COUNTRY_SLS';
export const FIELD_PATENT_TYPE = 'PATENT_TYPE';
export const FIELD_ANCS_TYPE = 'ANCS_TYPE';
export const FIELD_ANS_TYPE = 'ANS_TYPE';
export const FIELD_GOV = 'GOV';
export const FIELD_PN = 'PN';
export const FIELD_ICLMS = 'ICLMS';
export const FIELD_IN = 'IN';
export const FIELD_F_IN = 'F_IN';
export const FIELD_AT = 'AT';
export const FIELD_ATC = 'ATC';
export const FIELD_ATCS = 'ATCS';
export const FIELD_GNAME = 'GNAME';
export const FIELD_PE = 'PE';
export const FIELD_AE = 'AE';
export const FIELD_AN_ADD = 'AN_ADD';
export const FIELD_ANC_ADD = 'ANC_ADD';
export const FIELD_IN_ADDRESS = 'IN_ADDRESS';
export const FIELD_PRIORITY_COUNTRY = 'PRIORITY_COUNTRY';
export const FIELD_AUTHORITY = 'AUTHORITY';
export const FIELD_FI = 'FI';
export const FIELD_FTERM = 'FTERM';
export const FIELD_KD = 'KD';
export const FIELD_APNO = 'APNO';
export const FIELD_PRNO = 'PRNO';
export const FIELD_CITEDBY = 'F_CITES';
export const FIELD_FAM = 'FAM';
export const FIELD_IFAM = 'IFAM';
export const FIELD_EFAM = 'EFAM';
export const FIELD_CASENO = 'CASENO';
export const FIELD_COURT = 'COURT';
export const FIELD_CHIEF_JUDGE = 'CHIEF_JUDGE';
export const FIELD_JUDGE = 'JUDGE';
export const FIELD_PLAINTIFF = 'PLAINTIFF';
export const FIELD_DEFENDANT = 'DEFENDANT';
export const FIELD_CASE_TITLE = 'CASE_TITLE';
export const FIELD_CASE_FULL_TEXT = 'CASE_FULL_TEXT';
export const FIELD_OUTCOME_JUDGEMENT = 'OUTCOME_JUDGEMENT';
export const FIELD_LICENSOR = 'LICENSOR';
export const FIELD_LICENSEE = 'LICENSEE';
export const FIELD_LICENSE = 'LICENSE';
export const FIELD_TRANSFER_BEFORE = 'TRANSFER_BEFORE';
export const FIELD_TRANSFER_AFTER = 'TRANSFER_AFTER';
export const FIELD_TYPE = 'TYPE';
export const FIELD_PLEDGE = 'PLEDGE';
export const FIELD_PLEDGOR = 'PLEDGOR';
export const FIELD_PLEDGEE = 'PLEDGEE';
export const FIELD_PLEDGENO = 'PLEDGENO';
export const FIELD_PLE_STAGE = 'PLE_STAGE';
export const FIELD_REEXAMINVALID = 'REEXAMINVALID';
export const FIELD_RIDN = 'RIDN';
export const FIELD_RIIN = 'RIIN';
export const FIELD_RI_APPLICANT = 'RI_APPLICANT';
export const FIELD_RID = 'RID';
export const FIELD_RIDP = 'RIDP';
export const FIELD_RIDSM = 'RIDSM';
export const FIELD_RILGS = 'RILGS';
export const FIELD_RI_FULL_TEXT = 'RI_FULL_TEXT';
export const FIELD_LITIGATION = 'LITIGATION';
export const FIELD_LITIGATION_COUNTRY = 'LITIGATION_COUNTRY';
export const FIELD_PLAINTIFF_AND_DEFNAME = 'PLAINTIFF_AND_DEFNAME';
export const FIELD_CHEIFJUDGE_AND_JUDGE = 'CHEIFJUDGE_AND_JUDGE';
export const FIELD_DESC_ENTRANS = 'DESC_ENTRANS';
export const FIELD_DESC_CNTRANS = 'DESC_CNTRANS';
export const FIELD_CITE = 'B_CITES';
export const FIELD_PCT_APNO = 'PCT_APNO';
export const FIELD_PCT_PN = 'PCT_PN';
export const FIELD_CITE_CATEGORY = 'CITE_CATEGORY';
export const FIELD_COURTING_DATE = 'COURTING_DATE';
export const FIELD_DAMAGES_AMOUNT_PLAINTIFF = 'DAMAGES_AMOUNT_PLAINTIFF';
export const FIELD_COST_AMOUNT_PLAINTIFF = 'COST_AMOUNT_PLAINTIFF';
export const FIELD_COST_AMOUNT_COURT = 'COST_AMOUNT_COURT';
export const FIELD_DAMAGES_AMOUNT_COURT = 'DAMAGES_AMOUNT_COURT';
export const FIELD_AMOUNT_CALCULATE = 'AMOUNT_CALCULATE';
export const FIELD_MWS = 'MWS';
export const FIELD_CWS = 'CWS';
export const FIELD_EPDS_AND_LEGAL_STATUS = 'EPDS&SLS';
export const FIELD_ENTRY_COUNTRY_AND_LEGAL_STATUS = 'ENTRY_COUNTRY&ENTRY_COUNTRY_SLS';
export const FIELD_EPDS_COUNT = 'EPDS_COUNT';
export const FIELD_AWARD_COMBINE = 'COMBINE_AWARD';
export const FIELD_ATC_VALUE = 'ATC_VALUE';
export const FIELD_UP_STATUS = 'UP_STATUS';
export const FIELD_EFAM_STATUS = 'EFAM_STATUS';
export const FIELD_CITES_ANC_AND_CITE_CATEGORY = 'B_CITES_ANC&CITE_CATEGORY';
export const FIELD_CITEDBY_ANC_AND_CITE_CATEGORY = 'F_CITES_ANC&CITE_CATEGORY';
export const FIELD_CITEDBY_AND_CITE_CATEGORY = 'F_CITES&CITE_CATEGORY';
export const FIELD_CITE_AND_CITE_CATEGORY = 'B_CITES&CITE_CATEGORY';
export const FIELD_CWS_AND_CCF = 'CWS&CCF';
export const FIELDS_MULTI_DROPDOWN = [
    FIELD_PATENT_TYPE,
    FIELD_ANCS_TYPE,
    FIELD_ANS_TYPE,
    FIELD_LEGAL_STATUS,
    FIELD_LEGAL_EVENT,
    FIELD_SIMPLE_LEGAL_STATUS,
    FIELD_EP_LEGAL_STATUS,
    FIELD_EP_SIMPLE_LEGAL_STATUS,
    FIELD_ENTRY_COUNTRY_STATUS,
    FIELD_ENTRY_COUNTRY_LEGAL_STATUS,
    FIELD_EXCLUSIVITY,
    FIELD_EXCLUSIVITY_CN,
    FIELD_CITE_CATEGORY,
    FIELD_CASE_NATURE,
    FIELD_CASE_LEVEL,
    FIELD_CASE_DOC_TYPE,
    FIELD_COURT_GRADE,
    FIELD_ATC_VALUE,
    FIELD_UP_STATUS,
    FIELD_EFAM_STATUS
];
export const FIELDS_WORKSPACE = [
    FIELD_MWS,
    FIELD_CWS
];
export const FIELDS_COMBINE = [
    FIELD_EPDS_AND_LEGAL_STATUS,
    FIELD_ENTRY_COUNTRY_AND_LEGAL_STATUS,
    FIELD_CITES_ANC_AND_CITE_CATEGORY,
    FIELD_CITEDBY_ANC_AND_CITE_CATEGORY,
    FIELD_CITEDBY_AND_CITE_CATEGORY,
    FIELD_CITE_AND_CITE_CATEGORY,
    FIELD_CWS_AND_CCF
];
export const FIELDS_CHECK_AND_SEARCH = [
    FIELD_EPDS,
];
export const FIELDS_MULTI_CHECK = [
    FIELD_GOV,
];
export const FIELDS_DATE = [
    FIELD_APD,
    FIELD_PBD,
    FIELD_APD_Y,
    FIELD_PBD_Y,
    FIELD_APD_YM,
    FIELD_PBD_YM,
    FIELD_EFAM_EPBD,
    FIELD_EFAM_EPBY,
    FIELD_EFAM_EPBYM,
    FIELD_EFAM_EPRD,
    FIELD_ISD,
    FIELD_EXPD,
    FIELD_PRIORITY_DATE,
    FIELD_EXDT,
    FIELD_PCTENTRY_DATE,
    FIELD_LEGAL_STATUS_DATE,
    FIELD_VERDICT_DATE,
    FIELD_LIC_EFDT,
    FIELD_LIT_CLOSEDT,
    FIELD_FILING_DATE,
    FIELD_HEARING_DATE,
    FIELD_TRANS_EFDT,
    FIELD_PLE_EFDT,
    FIELD_RIDDT,
    FIELD_EXAMINE_DATE,
    FIELD_F_PBD,
    FIELD_E_PRIORITY_DATE,
    FIELD_FILING_YEAR,
    FIELD_COURTING_DATE,
];
export const FIELDS_SELECT = [
    FIELD_TRIAL_GRADE,
    FIELD_TRIAL_GRADE_CN,
    FIELD_CASE_REGION,
    FIELD_OUTCOME_STATUS,
    FIELD_PLE_STAGE,
    FIELD_RIDTP,
    FIELD_RIDTP_CN,
    FIELD_RIDTP_EP,
];
export const FIELDS_NUMBER = [
    FIELD_CITES_COUNT,
    FIELD_CITEDBY_COUNT,
    FIELD_FAM_COUNT,
    FIELD_IFAM_COUNT,
    FIELD_EFAM_COUNT,
    FIELD_FAM_COUNTRY_COUNT,
    FIELD_IFAM_COUNTRY_COUNT,
    FIELD_EFAM_COUNTRY_COUNT,
    FIELD_CLAIM_COUNT,
    FIELD_FCLMS_WORDCOUNT,
    FIELD_PV,
    FIELD_AN_COUNT,
    FIELD_ANC_COUNT,
    FIELD_IN_COUNT,
    FIELD_PAGE_COUNT,
    FIELD_EXAMINE_PERIOD,
    FIELD_CPC_COUNT,
    FIELD_IPC_COUNT,
    FIELD_PRIORITY_COUNTRY_COUNT,
    FIELD_AMOUNT_PLAINTIFF,
    FIELD_DAMAGES_AMOUNT,
    FIELD_DAMAGES_AMOUNT_PLAINTIFF,
    FIELD_COST_AMOUNT_PLAINTIFF,
    FIELD_COST_AMOUNT_COURT,
    FIELD_DAMAGES_AMOUNT_COURT,
    FIELD_EPDS_COUNT,
    // FIELD_AMOUNT_CALCULATE,
];
export const HELPER_KEYWORDS_SUPPORT_FIELDS = [
    FIELD_ALL,
    FIELD_MAINF,
    FIELD_TA,
    FIELD_TTL,
    FIELD_TAC,
    FIELD_TACD,
    FIELD_ABST,
    FIELD_CLMS,
    FIELD_DESC,
    FIELD_DESC_F,
    FIELD_DESC_B,
    FIELD_DESC_S,
    FIELD_DESC_D,
    FIELD_DESC_E,
    FIELD_I_CLMS,
    FIELD_ICLMS
];
export const HELPER_CORP_SUPPORT_FIELDS = [
    FIELD_ALL_AN,
    FIELD_ANS,
    FIELD_ANCS
];
// 拥有分类号助手的字段配置
export const HELPER_CLASSIFICATION_SUPPORT_FIELDS = [
    FIELD_IPC,
    FIELD_IPC_CPC,
    FIELD_MIPC,
    FIELD_CPC,
    FIELD_CPC_ALL,
    FIELD_MCPC,
    FIELD_LOC,
    FIELD_UPC,
    FIELD_GBC,
    FIELD_NEV,
    FIELD_FI,
    FIELD_FTERM,
    FIELD_ADC,
    FIELD_TTC,
    FIELD_SEIC,
    FIELD_SEIC_ALL
];
// 支持范围搜索分类号字段
export const RANGE_CLASSIFICATION_FIELDS = [FIELD_IPC, FIELD_CPC, FIELD_CPC_ALL, FIELD_MIPC, FIELD_MCPC, FIELD_LOC];
export const MACHINE_TRANSLATE_FIELDS_MAP_ALL = {
    DESC: FIELD_DESC_ALL,
    CLMS: FIELD_CLMS_ALL,
    ABST: FIELD_ABST_ALL,
    TA: FIELD_TA_ALL,
    TAC: FIELD_TAC_ALL,
    TTL: FIELD_TTL_ALL,
    TACD: FIELD_TACD_ALL,
    MAINF: FIELD_MAINF_ALL,
    ICLMS: FIELD_ICLMS_ALL
};
export const LEGAL_FIELDS_NO_SELECTOR = [
    FIELD_CASENO,
    FIELD_COURT,
    FIELD_CASE_TITLE,
    FIELD_CASE_FULL_TEXT,
    FIELD_OUTCOME_JUDGEMENT,
    FIELD_TRIAL_GRADE_CN,
    FIELD_CASE_NATURE,
    FIELD_CASE_LEVEL,
    FIELD_CASE_REGION,
    FIELD_OUTCOME_STATUS,
    FIELD_RIDN,
    FIELD_RIIN,
    FIELD_RI_APPLICANT,
    FIELD_RID,
    FIELD_RIDSM,
    FIELD_RILGS,
    FIELD_RI_FULL_TEXT,
    FIELD_RIDDT,
    FIELD_RIDP,
    FIELD_RIDTP_CN,
    FIELD_RIDTP,
    FIELD_RIDTP_EP,
    FIELD_LICENSOR,
    FIELD_LICENSEE,
    FIELD_EXCLUSIVITY,
    FIELD_LIC_EFDT,
    FIELD_TRANSFER_BEFORE,
    FIELD_TRANSFER_AFTER,
    FIELD_TRANS_EFDT,
    FIELD_PLEDGOR,
    FIELD_PLEDGEE,
    FIELD_PLEDGENO,
    FIELD_PLE_EFDT,
    FIELD_PLE_STAGE
];
export const LEGAL_FIELDS_WITH_SELECTOR = [
    FIELD_PLAINTIFF,
    FIELD_CHIEF_JUDGE,
    FIELD_VERDICT_DATE
];
export const LEGAL_FIELDS = LEGAL_FIELDS_WITH_SELECTOR.concat(LEGAL_FIELDS_NO_SELECTOR);
